// extracted by mini-css-extract-plugin
export default {"layout":"layout_layout__X9SOl","body":"layout_body__MjpUX","project":"layout_project__puZx9","label":"layout_label__cTgJN","select":"layout_select__uH95A"};